export function DemoSkeleton() {
  return (
    <div className="w-full h-full bg-device-skeleton animate-pulse flex flex-col gap-4 p-6">
      <div className="flex gap-4">
        <div className="w-40 h-32 bg-white/5 rounded-xl" />
        <div className="flex-1 flex flex-col gap-3">
          <div className="h-6 w-3/4 bg-white/5 rounded" />
          <div className="h-4 w-1/2 bg-white/5 rounded" />
          <div className="h-4 w-2/3 bg-white/5 rounded" />
        </div>
      </div>
      <div className="grid grid-cols-4 gap-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="h-20 bg-white/5 rounded-xl" />
        ))}
      </div>
      <div className="flex-1 bg-white/5 rounded-xl" />
    </div>
  );
}
